import { render, staticRenderFns } from "./IbDialog.vue?vue&type=template&id=03d3dae1&scoped=true"
import script from "./IbDialog.vue?vue&type=script&lang=js"
export * from "./IbDialog.vue?vue&type=script&lang=js"
import style0 from "./IbDialog.vue?vue&type=style&index=0&id=03d3dae1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d3dae1",
  null
  
)

export default component.exports